import { ReservableCrossSell } from '~/components/Restaurant/ReservableCrossSellItem/ReservableCrossSellItem'
import { ReservableExtraCard, ReservableExtraCardItem } from '~/components/Restaurant/ReservableExtraCard/ReservableExtraCard'
import { ReservableTabHeader } from '~/components/Restaurant/ReservableTabHeader/ReservableTabHeader'
import { Restaurant } from '~/generated/graphql'
import { gt } from '~/locale'

import { Wrapper } from './ReservableExtraMenuShards'

type ChmMenuTabProps = {
  restaurant: Pick<Restaurant, 'id'> & {
    reservableExtras: ReservableExtraCardItem[]
  }
  crossSells: ReservableCrossSell[]
  onReserveClick: () => void
}

export const ReservableExtraMenuTab = ({ restaurant, crossSells, onReserveClick }: ChmMenuTabProps) => {
  return (
    <Wrapper>
      <ReservableTabHeader
        title={gt.tp('RestaurantPage', "Bargain price! Discover this restaurant through the Chef's signature menu.")}
        subtitle={gt.tp('RestaurantPage', 'Promotional set: 3 courses')}
      />
      {restaurant.reservableExtras.map(reservableExtra => (
        <ReservableExtraCard
          key={reservableExtra.id}
          reservableExtra={reservableExtra}
          crossSells={crossSells}
          onReserveClick={onReserveClick}
        />
      ))}
    </Wrapper>
  )
}
